<template>
  <Layout1 :title="adminApprovalRequired ? 'Thanks for signing up!' : 'Check your email!'">
    <template v-if='!adminApprovalRequired' slot="form">
      <form @submit.prevent="sendVerificationCode()">
      <div class="form-floating">
        <p class="col_secondary  fn14 ln_ht20 fw400">You're almost there! Follow the instructions sent to you on your email address <span class="fw700">{{email}}</span> to confirm your email address.</p>
      </div>
      <div class="mb20 mt20">
        <input type="submit" class="btn btn-apiculus-primary" value="RESEND VERIFICATION MAIL" />
      </div>
      </form>
    </template>
    <template v-if='adminApprovalRequired' slot="form">
      <form @submit.prevent="routeTo()">
      <div class="form-floating">
        <p class="col_secondary fn14 ln_ht20 fw400">We have recieved your request for registration. You will soon recieve an email with further instructions</p>
      </div>
      <div class="mb20 mt20">
        <input type="submit" class="btn btn-apiculus-primary" value="Click here to login" />
      </div>
      </form>
    </template>
  </Layout1>
</template>

<script>
import helpers from '../../services/toast-service'
import Layout1 from './Layout1.vue'

export default {
  name: 'ResendVerificationCode',
  mixins: [helpers],
  data () {
    return {
      color: '',
      message: '',
      email: '',
      adminApprovalRequired: JSON.parse(localStorage.getItem('ApiculusEnv')).adminApprovalRequired ? JSON.parse(localStorage.getItem('ApiculusEnv')).adminApprovalRequired : false
    }
  },
  components: {
    Layout1
  },
  methods: {
    routeTo () {
      this.$router.push('/')
    },
    sendVerificationCode () {
      this.$store.dispatch('ACTION_RESEND_EMAIL', { email: this.email }).then((res) => {
        if (!res.success) {
          this.toastAlert(res.error.message || 'Something went wrong.', 'error')
        } else {
          this.toastAlert('Verification email sent, Please check your inbox.', 'success')
        }
      })
    }
  },
  // mounted () {
  //   let userDetails = this.$route.params
  //   if (!(Object.keys(userDetails).length > 0)) {
  //     this.$router.push('/signup2')
  //   } else {
  //     this.email = userDetails.email
  //   }
  // },
  created () {
    this.email = this.$route.query.email
    // this.email = Object.values(this.$route.query).reduce((a,b)=>{
    //   return a+b
    // })
  }
}
</script>

<style scoped>

</style>
